const getWishlisted = (sku, items)=>{
    const isWishlisted = items === null || items === void 0 ? void 0 : items.find((item)=>item.sku === sku
    );
    return !!isWishlisted;
};

export { getWishlisted };
//# sourceMappingURL=get-wishlisted.js.map
